import React from 'react';
import UploadDocumentForm from './UploadDocumentForm/UploadDocumentForm';
import './UploadDocument.scss';
const UploadDocument = () => {
  return (
    <>
      <h1 className="text-center mrg-t30">Upload Documents</h1>
      <p className="textCenter">Pdf and images(jpeg,jpg,png) are allowed</p>
      <UploadDocumentForm />
    </>
  );
};

export default UploadDocument;
